import { render, staticRenderFns } from "./CommonWriteSxResult.vue?vue&type=template&id=5999da50&scoped=true"
import script from "./CommonWriteSxResult.vue?vue&type=script&lang=js"
export * from "./CommonWriteSxResult.vue?vue&type=script&lang=js"
import style0 from "./CommonWriteSxResult.vue?vue&type=style&index=0&id=5999da50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5999da50",
  null
  
)

export default component.exports